import styled from "@emotion/styled";
import { secondaryText, Theme } from "@silvertours/front-shared";
var IconGridContainer = /*#__PURE__*/ styled("div", {
    target: "e1t9q3ib0"
})("height:100%;display:flex;width:100%;gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("xl");
}, "{height:146px;}");
var IconWrapper = /*#__PURE__*/ styled("div", {
    target: "e1t9q3ib1"
})("background-image:", function(param) {
    var theme = param.theme;
    return Theme.getLinearGradient(theme.gradient.orange, "270deg");
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:100%;", function(param) {
    var theme = param.theme;
    return theme.mq("xl");
}, "{width:146px;}& svg{max-height:104px;}");
var Label = /*#__PURE__*/ styled("div", {
    target: "e1t9q3ib2"
})(secondaryText, "  margin:", function(param) {
    var theme = param.theme;
    return theme.spacing[10];
}, ";justify-self:center;");
export { IconWrapper, IconGridContainer, Label };
